import * as ACTION_TYPES from "../types";

let initialState = {
  bankList: [],
  banksBins: {},
  loading: false,
  error: false,
  binList: [],
  binListById: [],
  singleBin: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_ALL_BANKS:
      return { ...state, bankList: action.data };
    case ACTION_TYPES.GET_BANKS_BIN_LIST:
      return { ...state, banksBins: action.data };
    case ACTION_TYPES.GET_ALL_BINS:
      return { ...state, binList: action.data };
    case ACTION_TYPES.GET_BINS_BY_ID:
      return { ...state, binListById: action.data };
    case ACTION_TYPES.GET_SINGLE_BIN:
      return { ...state, singleBin: action.data };
    default:
      return state;
  }
};
